<template>
   <plan-list/>
</template>

<script>
import PlanList from '@/components/organisms/Home/Plan/PlanList';

export default {
   name: "admin-plans",
   components: {
      PlanList,
   },
}
</script>

<style lang="scss">
</style>
